var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from 'react';
import { arrayOf, func, oneOf, oneOfType, node, number, shape, string, any, bool } from 'prop-types';
import styles from './Breadcrumbs.scss';
import classnames from 'classnames';
import WixComponent from '../BaseComponents/WixComponent';
import Text from '../Text';
import BreadcrumbsPathFactory from './BreadcrumbsPathFactory';

var Breadcrumbs = function (_WixComponent) {
  _inherits(Breadcrumbs, _WixComponent);

  function Breadcrumbs() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Breadcrumbs);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Breadcrumbs.__proto__ || Object.getPrototypeOf(Breadcrumbs)).call.apply(_ref, [this].concat(args))), _this), _this.handleBreadcrumbClick = function (item) {
      return _this.props.onClick && _this.props.onClick(item);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Breadcrumbs, [{
    key: 'getValueAppearance',
    value: function getValueAppearance(isActive) {
      var _props = this.props,
          theme = _props.theme,
          size = _props.size;


      var isDarkBackground = theme === 'onDarkBackground';
      var isMediumSize = size === 'medium';

      if (isActive && !isDarkBackground) {
        return isMediumSize ? 'T3' : 'T1';
      }

      if (isMediumSize) {
        return isDarkBackground ? 'T3.2' : 'T3.1';
      } else {
        return isDarkBackground ? 'T1.2' : 'T1.1';
      }
    }
  }, {
    key: 'createItem',
    value: function createItem(_ref2) {
      var _this2 = this;

      var item = _ref2.item,
          isActive = _ref2.isActive,
          onClick = _ref2.onClick;

      var breadcrumbValue = function breadcrumbValue(value) {
        return React.createElement(Text, {
          dataHook: 'breadcrumbs-item',
          appearance: _this2.getValueAppearance(isActive),
          children: value
        });
      };

      var defaultBreadcrumb = function defaultBreadcrumb() {
        var _classnames;

        return React.createElement('button', {
          type: 'button',
          'data-hook': 'breadcrumb-clickable',
          className: classnames(styles.item, styles.button, (_classnames = {}, _defineProperty(_classnames, styles.disabled, item.disabled), _defineProperty(_classnames, styles.active, isActive), _classnames)),
          onClick: onClick,
          children: breadcrumbValue(item.value)
        });
      };

      var linkBreadcrumb = function linkBreadcrumb() {
        var _classnames2;

        return React.createElement('a', {
          href: item.link,
          'data-hook': 'breadcrumb-clickable',
          className: classnames(styles.item, styles.link, (_classnames2 = {}, _defineProperty(_classnames2, styles.disabled, item.disabled), _defineProperty(_classnames2, styles.active, isActive), _classnames2)),
          onClick: onClick,
          children: breadcrumbValue(item.value)
        });
      };

      var customBreadcrumb = function customBreadcrumb() {
        return React.createElement('span', {
          'data-hook': 'breadcrumb-clickable',
          className: styles.item,
          onClick: onClick,
          children: breadcrumbValue(item.customElement)
        });
      };

      if (isActive) {
        return defaultBreadcrumb();
      } else if (item.customElement) {
        return customBreadcrumb();
      } else if (item.link) {
        return linkBreadcrumb();
      } else {
        return defaultBreadcrumb();
      }
    }
  }, {
    key: 'renderItem',
    value: function renderItem(item, activeId, isDividerVisible) {
      var _this3 = this;

      var isActive = activeId === item.id;

      return React.createElement(
        'div',
        {
          key: item.id,
          className: classnames(styles.itemContainer, _defineProperty({}, styles.active, isActive))
        },
        this.createItem({ item: item, isActive: isActive, onClick: function onClick() {
            return item.disabled !== true && _this3.handleBreadcrumbClick(item);
          } }),
        isDividerVisible && React.createElement('div', { className: styles.divider })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _props2 = this.props,
          items = _props2.items,
          size = _props2.size,
          theme = _props2.theme,
          activeId = _props2.activeId;


      return React.createElement(
        'div',
        { className: classnames(styles[size], styles[theme]) },
        items.map(function (item, i, allItems) {
          return _this4.renderItem(item, activeId, allItems[i + 1]);
        })
      );
    }
  }]);

  return Breadcrumbs;
}(WixComponent);

Breadcrumbs.propTypes = {
  items: arrayOf(shape({
    id: oneOfType([string, number]).isRequired,
    value: oneOfType([node, string]).isRequired,
    link: string,
    customElement: any,
    disabled: bool
  })).isRequired,
  onClick: func,
  activeId: oneOfType([string, number]),
  size: oneOf(['medium', 'large']),
  theme: oneOf(['onWhiteBackground', 'onGrayBackground', 'onDarkBackground'])
};
Breadcrumbs.defaultProps = {
  size: 'medium',
  theme: 'onGrayBackground'
};


export var breadcrumbsPathFactory = BreadcrumbsPathFactory;
export default Breadcrumbs;
//# sourceMappingURL=Breadcrumbs.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/Breadcrumbs/Breadcrumbs.js